import SingleSelectHookForm from "Components/CommonComponents/SingleSelectHookForm";
import { LoginFormFields } from "Pages/UserManagement/UserManagementForm";
import React from "react";
import { useForm } from "react-hook-form";
import { Card, Spinner } from "reactstrap";
export interface ChapterListViewComponentMBInterface {
  chapterList: any[];
  selectedChapter: any;
  togglePane?: any;
  loading: any;
  setSelectedChapter: any;
}
const ChapterListViewComponentMB = ({
  loading,
  chapterList,
  selectedChapter,
  setSelectedChapter,
}: ChapterListViewComponentMBInterface) => {
  console.log("chapterList====", chapterList, selectedChapter);
  const dateViewData = chapterList
    ? chapterList.map((item: any) => ({
        label: item.title,
        value: item.id,
        key: item.id,
      }))
    : [];
  const {
    register,
    control,
    formState: { errors },
  } = useForm<LoginFormFields>();
  return (
    <Card className="dateListContainer p-2">
      {loading ? (
        <Spinner color="info"></Spinner>
      ) : (
        <SingleSelectHookForm
          disabled={false}
          error={errors}
          controlName={control}
          placeholder="Select Chapter"
          width="100%"
          isInPerformance={false}
          options={dateViewData}
          menuPlacement="bottom"
          isClearable={false}
          isSearchable={false}
          isSearchableDrop={true}
          isDropdownSelect={true}
          top={"0px"}
          menuShouldScrollIntoView={true}
          closeMenuOnSelect={true}
          hideSelectedOptions={false}
          name={"date"}
          register={register}
          onChange={(selected: any) => {
            const obj = {
              title: selected.label,
              id: selected.value,
              sequence: 1,
            };
            setSelectedChapter(obj);
            console.log("selected", selected);
          }}
          defaultValue={dateViewData[0] ? dateViewData[0] : null}
        />
      )}
    </Card>
  );
};

export default ChapterListViewComponentMB;
